import NotifySettingsPageView from 'src/pages/NotifySettingPage/view'
import { QueryClient } from '@tanstack/react-query'
import { notifyListQueryOption, useCustomQuery } from 'src/hooks/react-query/useCustomQuery.hook'
import {
  notifyUpdateSubmitQueryOption,
  useCustomMutation,
} from 'src/hooks/react-query/useCustomMutation.hook'
import { ModalSpace, useModal } from 'src/provider/ModalContextProvider'
import { DateUtils } from 'src/utils/date'
import { Bridge } from 'src/utils/bridge'

export type notifyOptionType = 0 | 1

export type toggleDataListType = {
  text: string
  subtext?: string
  status: boolean
  type: notifyOptionType
  modalItems: ModalSpace.ModalData
}

export interface NotifySettingsPageProps {
  onToggleChangeHandler: (type: number) => void
  toggleDataList: toggleDataListType[]
  naviAppSystemNotifyPage: () => void
}

export const notifyPageLoader = (queryClient: QueryClient) => async () => {
  const dataQueryValues = [await queryClient.ensureQueryData(notifyListQueryOption())]
  return Promise.allSettled(dataQueryValues)
}

const NotifySettingsPage = () => {
  const { openModal } = useModal()
  const { now, DateFormat } = DateUtils
  const { data: notifyListQueryData, refetch: notifyListRefetch } =
    useCustomQuery(notifyListQueryOption())
  const { Marketing } = notifyListQueryData?.Body!
  const { mutateAsync: NotifyUpdateMutate } = useCustomMutation(notifyUpdateSubmitQueryOption())

  const notifyUpdateSubmit = () => {
    NotifyUpdateMutate({ Type: 0, On: !Marketing }).then(() => {
      notifyListRefetch?.()
    })
  }

  const naviAppSystemNotifyPage = () => Bridge.handleReqSystemNotification()

  const marketingAgreeCancelHandler = () => {
    notifyUpdateSubmit()

    openModal({
      contents: {
        t: '혜택(광고성) 알림 거부처리 결과',
        d: `전송자: 데이터유니버스 \n 일시: ${DateFormat(
          now(),
          'YYYY년 MM월 DD일',
        )}  \n 내용: 광고성 정보 수신거부 처리 완료 `,
      },
      button: { submit: { t: '확인' } },
    })
  }

  const toggleDataList: toggleDataListType[] = [
    {
      type: 0,
      text: '마케팅 수신동의',
      status: Marketing,
      modalItems: !Marketing
        ? {
            contents: {
              t: '혜택(광고성) 알림 수신',
              d: `전송자 : 데이터유니버스 \n일시 : ${DateFormat(
                now(),
                'YYYY년 MM월 DD일',
              )}\n내용 : 광고성 정보 수신 동의 완료 `,
            },
            button: { submit: { t: '확인' } },
          }
        : {
            contents: {
              t: '혜택(광고성)알림 수신',
              d: '할인쿠폰, 핫딜 등 고객님을 위한 다양한 쇼핑혜택 관련 알림을 더 이상 받을 수 없게 됩니다. 정말 알림을 해제하시겠어요?',
            },
            button: {
              submit: { t: '알림 해제', f: marketingAgreeCancelHandler },
              cancel: { t: '알림 유지' },
            },
          },
    },
  ]

  const onToggleChangeHandler = (type: number) => {
    const findModalItems = toggleDataList?.find((w) => w.type === type)?.modalItems
    !Marketing && notifyUpdateSubmit()
    openModal(findModalItems as ModalSpace.ModalData)
  }

  const props = {
    toggleDataList,
    onToggleChangeHandler,
    naviAppSystemNotifyPage,
  }
  return <NotifySettingsPageView {...props} />
}
export default NotifySettingsPage
